import { Tag } from "antd";

function tagByStatus(status) {
    switch (status) {
        case "Approved":
            return (
                <Tag color="success">{status}</Tag>
            )
        case "Cancelled":
            return (<Tag color="error">{status}</Tag>)
        case "Rejected":
            return (<Tag color="error">{status}</Tag>)
        case "คำขอถูกยกเลิก":
            return (<Tag color="error">{status}</Tag>)
        case "อนุมัติ":
            return (<Tag color="success">{status}</Tag>)
        case "อนุมัติคำขอ":
            return (<Tag color="success">{status}</Tag>)
        case "ยกเลิกคำขอ":
            return (<Tag color="error">{status}</Tag>)
        case "คำขอถูกปฎิเสธ":
            return (<Tag color="error">{status}</Tag>)
        default:
            return (<Tag color="processing">{status}</Tag>)
    }
}

export default tagByStatus